<template>
  <main
    role="main"
    class="col content-spacing"
    style="max-width: 88% !important;"
  >
    <PageHeader pageTitle="Panorama" style="padding-top: 1rem;">
      <div style="gap: 1rem; display: flex; flex-direction: column;">
        <div style="display: flex; gap: 0.5rem; align-items: center;">
          <span style="font-size: 1rem;">De</span>
          <SelectMonth v-model="search.startMonth" style="max-width: 120px;" />
          <SelectYear v-model="search.startYear" style="max-width: 80px;" />
          <span style="font-size: 1rem;">Até</span>
          <SelectMonth v-model="search.endMonth" style="max-width: 120px;" />
          <SelectYear v-model="search.endYear" style="max-width: 80px;" />

          <div style="display: flex; align-items: center;">
            <b-button
              variant="primary"
              @click="getAll()"
              class="btn btn-primary-action"
            >
              Buscar
            </b-button>
          </div>
          <hr
            data-v-2297aafa=""
            class="vertical-bar"
            style="transform: translateY(-25%);"
          />
          <GenericSearchInput
            :placeHolder="'Buscar'"
            v-model="search.textSearch"
            style="max-width: 250px !important;"
          />
          <SelectPanoramaInstallationStatus
            v-model="search.installationStatus"
            style="max-width: 150px;"
          />
          <SelectBillingStatus
            v-model="search.billingStatus"
            style="max-width: 150px; min-width: none;"
          />
          <SelectAccountManager
            v-model="search.accountManagerId"
            style="max-width: 150px;"
          />
          <SelectPromoter
            v-if="panoramaList.length"
            :traderList="traderList"
            v-model="search.trader"
            style="max-width: 150px;"
          />
          <div>
            <b-dropdown id="dropdown-checkbox" text="Campos" class="m-2">
              <b-dropdown-item @click="toggleAllFields()">
                <span v-if="Object.values(this.selectedFields).includes(false)">
                  Marcar todos
                </span>
                <span v-else>Desmarcar todos</span>
              </b-dropdown-item>
              <div class="p-1">
                <b-form-checkbox
                  v-model="selectedFields.invoiceValue"
                  @click.stop
                >
                  Valor da fatura ($)
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="selectedFields.qtyInvoices"
                  @click.stop
                  class="mt-2"
                >
                  Quantidade (#)
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="selectedFields.averageTicket"
                  @click.stop
                  class="mt-2"
                >
                  Ticket Médio (TM)
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="selectedFields.overallPercentage"
                  @click.stop
                  class="mt-2"
                >
                  Porcentagem vertical (V)
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="selectedFields.subTotalPercentage"
                  @click.stop
                  class="mt-2"
                >
                  Porcentagem horizontal (H)
                </b-form-checkbox>
              </div>
            </b-dropdown>
          </div>
        </div>
      </div>
    </PageHeader>

    <b-skeleton-table
      animation="wave"
      style="margin-top: 2rem;"
      :rows="5"
      :columns="15"
      :table-props="{ bordered: true, striped: true }"
      v-if="isLoading"
    />

    <section v-if="this.panoramaStatusSummaryList && !isLoading">
      <NewPanoramaSummaryTable
        :panoramaStatusSummaryList="panoramaStatusSummaryList"
        :panoramaMonthsColumns="panoramaMonthsColumns"
        :selectedFields="selectedFields"
      />
    </section>

    <section
      class="d-flex justify-content-between flex-column"
      v-if="!isLoading && panoramaList.length"
    >
      <Table class="panorama-table">
        <TableHeader>
          <TableRow>
            <TableHead
              v-for="(panoramaCol, index) of panoramaColumns"
              v-if="panoramaCol.visible"
              :key="`${panoramaCol.name}_${index}`"
              :class="panoramaCol.class"
              :style="setInvoiceStatusColor(panoramaCol.name)"
            >
              <div
                :style="
                  panoramaCol.key === 'name'
                    ? 'display: flex; align-items: center; justify-content: space-between;'
                    : ''
                "
              >
                <ColumnHeader
                  :sort="panoramaCol.sort"
                  :somatory="panoramaCol.somatory"
                  :columnName="panoramaCol.name"
                  :columnKey="panoramaCol.key"
                  :columnType="panoramaCol.columnType"
                  :currentColumnFiltered="currentColumnFiltered"
                  :sortDirection="sortDirection"
                  :dataList="panoramaList"
                  v-on:sortListByKey="sortListByKey(panoramaCol.key)"
                />

                <template v-if="panoramaCol.key === 'name'">
                  <b-button
                    @click="toggleMonthsVisibility()"
                    size="sm"
                    variant="outline-secondary"
                  >
                    <span v-if="monthsVisible">
                      Agrupar
                    </span>
                    <span v-else> Desagrupar</span>
                  </b-button>
                </template>
              </div>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow
            v-for="(panorama, index) of panoramaList"
            :key="`${panorama.name}_${index}`"
          >
            <TableCell>
              {{ panorama.installationNumber }}
            </TableCell>
            <TableCell>
              <RenderNameColumnValue :name="panorama.name" :maxLength="40" />
            </TableCell>
            <TableCell
              class="divider"
              :style="setInstallationStatusColor(panorama.installationStatus)"
            >
              <div style="width: 105px;">
                {{ translateInstallationStatus(panorama.installationStatus) }}
              </div>
            </TableCell>
            <template
              v-if="monthsVisible"
              v-for="(invoiceData, index) in Array.from(panorama.invoicesData)"
            >
              <TableCell class="money-cell" style="min-width: 130px;">
                <RenderPanoramaInvoiceLine
                  v-if="invoiceData.status !== 'NO_DATA'"
                  :invoice-value="invoiceData.boletoVeins"
                  :panorama-invoice-status="
                    convertOldStatusToNewStatus(invoiceData.status)
                  "
                />
              </TableCell>
            </template>

            <TableCell
              class="money-cell divider total"
              style="border-left: 2px solid gray !important;"
            >
              <RenderPanoramaGroupedStatusColumn
                :value="panorama.totalValue"
                :qty="
                  panorama.qtyPaidInvoice +
                    panorama.qtyOpenInvoice +
                    panorama.qtyAgreementInvoice +
                    panorama.qtyOverdueInvoice +
                    panorama.qtyLossInvoice
                "
                :percent="(panorama.totalValue / panorama.totalValue) * 100"
              />
            </TableCell>
            <TableCell
              class="money-cell"
              :style="setInvoiceStatusColor('[PG] Pago')"
            >
              <RenderPanoramaGroupedStatusColumn
                :value="panorama.totalPaidInvoiceValue"
                :qty="panorama.qtyPaidInvoice"
                :percent="
                  (panorama.totalPaidInvoiceValue / panorama.totalValue) * 100
                "
              />
            </TableCell>
            <TableCell
              class="money-cell"
              :style="setInvoiceStatusColor('[AB] Aberto')"
            >
              <RenderPanoramaGroupedStatusColumn
                :value="panorama.totalOpenInvoiceValue"
                :qty="panorama.qtyOpenInvoice"
                :percent="
                  (panorama.totalOpenInvoiceValue / panorama.totalValue) * 100
                "
              />
            </TableCell>
            <TableCell
              class="money-cell"
              :style="setInvoiceStatusColor('[DE] Acordo')"
            >
              <RenderPanoramaGroupedStatusColumn
                :value="panorama.totalAgreementInvoiceValue"
                :qty="panorama.qtyAgreementInvoice"
                :percent="
                  (panorama.totalAgreementInvoiceValue / panorama.totalValue) *
                    100
                "
              />
            </TableCell>
            <TableCell
              class="money-cell"
              :style="setInvoiceStatusColor('[NA] Inadimplente')"
            >
              <RenderPanoramaGroupedStatusColumn
                :value="panorama.totalOverdueInvoiceValue"
                :qty="panorama.qtyOverdueInvoice"
                :percent="
                  (panorama.totalOverdueInvoiceValue / panorama.totalValue) *
                    100
                "
              />
            </TableCell>
            <TableCell
              class="money-cell divider"
              :style="setInvoiceStatusColor('[RD] Perda')"
            >
              <RenderPanoramaGroupedStatusColumn
                :value="panorama.totalLossInvoiceValue"
                :qty="panorama.qtyLossInvoice"
                :percent="
                  (panorama.totalLossInvoiceValue / panorama.totalValue) * 100
                "
              />
            </TableCell>
            <TableCell>
              <RenderNameColumnValue
                v-if="panorama.accountManagerName"
                :name="panorama.accountManagerName"
              />
            </TableCell>
            <TableCell>
              <RenderNameColumnValue
                v-if="panorama.traderName"
                :name="panorama.traderName"
              />
            </TableCell>
            <TableCell>
              <RenderSocialNumberColumnValue
                :social-number="panorama.socialNumber"
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </section>
    <empty-list v-else-if="!isLoading" />
  </main>
</template>

<script>
import {
  SelectPanoramaInstallationStatus,
  RenderPanoramaGroupedStatusColumn,
} from '../../modules/new-panorama/components';
import RenderPanoramaInvoiceLine from '../../modules/new-panorama/components/render-panorama-invoice-line-value.vue';
import { NewPanoramaSummaryTable } from '../../modules/new-panorama/components';
import { SelectBillingStatus } from '../../modules/new-panorama/components';
import {
  SelectMonth,
  SelectYear,
  SelectPromoter,
  SelectAccountManager,
} from '../../ui/selects';
import { GenericSearchInput } from '../../ui/inputs';
import { PageHeader } from '../../ui/page-header';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../ui/table';
import { ColumnHeader } from '../../ui/column-header';
import { Api } from '../../vue/api';
import helpers from '../../vue/helpers';
import {
  RenderDateColumnValue,
  RenderMoneyColumnValue,
  RenderNameColumnValue,
  RenderSocialNumberColumnValue,
} from '../../ui/render';
import { INSTALLATION_STATUS_IN_PTBR } from '../../modules/installation/constants';
import {
  PANORAMA_INVOICE_GROUPED_STATUS,
  OLD_TO_NEW_STATUS,
  PANORAMA_INVOICE_STATUS,
  PANORAMA_INVOICE_SUBGROUPS,
  PANORAMA_INVOICE_GROUPS,
  NEW_TO_OLD_STATUS,
} from '../../modules/new-panorama/constants';
import { defineArrowDirection, sortByProperty } from '../../utils';
import {
  sortPanoramaInvoiceByBoletoVeins,
  setPanoramaInvoiceInstallationStatusColor,
  setPanoramaInvoiceStatusColor,
} from '../../modules/new-panorama/utils';
const API = new Api();

/**
 * @typedef {Object} InvoiceData
 * @property {number} boletoVeins
 * @property {string} status
 */

/**
 * Objeto que representa as Faturas de cada Instalção para a construção da tabela de Panorama
 * @typedef {Object} PanoramaInvoice
 * @property {number} id
 * @property {number} installationNumber
 * @property {string} name
 * @property {"CONNECTING" | "ACTIVE" | "INACTIVATION_REQUESTED" | "DISCONNECTED" | "DEBT" | "INACTIVE" | "SETTLEMENT" | "WRONG_OWNER"} installationStatus
 * @property {number} totalValue
 * @property {number} qtyOverdueInvoice
 * @property {number} totalOverdueInvoiceValue
 * @property {InvoiceData | null} janInvoiceData
 * @property {InvoiceData | null} febInvoiceData
 * @property {InvoiceData | null} marInvoiceData
 * @property {InvoiceData | null} aprInvoiceData
 * @property {InvoiceData | null} mayInvoiceData
 * @property {InvoiceData | null} junInvoiceData
 * @property {InvoiceData | null} julInvoiceData
 * @property {InvoiceData | null} augInvoiceData
 * @property {InvoiceData | null} sepInvoiceData
 * @property {InvoiceData | null} octInvoiceData
 * @property {InvoiceData | null} novInvoiceData
 * @property {InvoiceData | null} decInvoiceData
 * @property {number} qtyDaysInStatus
 * @property {string} dueDate
 * @property {string} socialNumber
 * @property {string} traderName
 * @property {string} accountManagerName
 */

/**
 * @typedef {Object} PanoramaStatusSummary
 * @property {string} name
 * @property {number} total
 * @property {number} subtotal
 * @property {InvoiceData[] | null} january
 * @property {InvoiceData[] | null} february
 * @property {InvoiceData[] | null} march
 * @property {InvoiceData[] | null} april
 * @property {InvoiceData[] | null} may
 * @property {InvoiceData[] | null} june
 * @property {InvoiceData[] | null} july
 * @property {InvoiceData[] | null} august
 * @property {InvoiceData[] | null} september
 * @property {InvoiceData[] | null} october
 * @property {InvoiceData[] | null} november
 * @property {InvoiceData[] | null} december
 */

export default {
  components: {
    SelectPanoramaInstallationStatus,
    SelectBillingStatus,
    GenericSearchInput,
    SelectPromoter,
    SelectMonth,
    SelectYear,
    PageHeader,
    NewPanoramaSummaryTable,
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHead,
    ColumnHeader,
    TableCell,
    RenderNameColumnValue,
    RenderMoneyColumnValue,
    RenderDateColumnValue,
    RenderSocialNumberColumnValue,
    RenderPanoramaInvoiceLine,
    RenderPanoramaGroupedStatusColumn,
    SelectAccountManager,
  },
  data() {
    const now = new Date();
    const currentYear = now.getFullYear().toString();
    const currentMonth = (now.getMonth() + 1).toString().padStart(2, '0');

    return {
      isLoading: false,
      search: {
        textSearch: null,
        installationStatus: null,
        trader: null,
        billingStatus: null,
        startMonth: '01',
        startYear: currentYear,
        endMonth: currentMonth,
        endYear: currentYear,
        accountManagerId: null,
      },
      traderList: [],
      /**
       * Lista de faturas das instalações com dados preservados da consulta a API
       * @type {PanoramaInvoice[]}
       */
      panoramaList: [],

      currentColumnFiltered: '',
      sortDirection: 'ASC',
      panoramaMonthsColumns: [],
      initialPanoramaColumns: [
        {
          name: 'Instalação',
          key: 'installationNumber',
          columnType: '',
          sort: false,
          somatory: false,
          visible: true,
        },
        {
          name: 'Nome',
          key: 'name',
          columnType: '',
          sort: true,
          somatory: false,
          visible: true,
        },
        {
          name: 'Status',
          key: 'status',
          columnType: '(QTY)',
          sort: false,
          somatory: true,
          class: 'divider',
          visible: true,
        },
        {
          name: 'Total',
          key: 'totalValue',
          columnType: '(R$)',
          sort: true,
          somatory: true,
          class: 'divider total',
          visible: true,
        },
        {
          name: '[PG] Pago',
          key: 'totalPaidInvoiceValue',
          columnType: '(R$)',
          sort: true,
          somatory: true,
          visible: true,
        },
        {
          name: '[AB] Aberto',
          key: 'totalOpenInvoiceValue',
          columnType: '(R$)',
          sort: true,
          somatory: true,
          visible: true,
        },
        {
          name: '[DE] Acordo',
          key: 'totalAgreementInvoiceValue',
          columnType: '(R$)',
          sort: true,
          somatory: true,
          visible: true,
        },
        {
          name: '[NA] Inadim.',
          key: 'totalOverdueInvoiceValue',
          columnType: '(R$)',
          sort: true,
          somatory: true,
          visible: true,
        },
        {
          name: '[RD] Perda',
          key: 'totalLossInvoiceValue',
          columnType: '(R$)',
          sort: true,
          somatory: true,
          class: 'divider',
          visible: true,
        },
        {
          name: 'CS',
          key: 'accountManagerName',
          columnType: '',
          sort: true,
          somatory: false,
          visible: true,
        },
        {
          name: 'Promotor',
          key: 'traderName',
          columnType: '',
          sort: true,
          somatory: false,
          visible: true,
        },
        {
          name: 'CPF/CNPJ',
          key: 'socialNumber',
          columnType: '',
          sort: false,
          somatory: false,
          visible: true,
        },
      ],
      /**
       * Lista com o resumo de faturas por status
       * @type {PanoramaStatusSummary[]}
       */
      panoramaStatusSummaryList: [],
      selectedFields: {
        invoiceValue: true,
        qtyInvoices: true,
        overallPercentage: true,
        subTotalPercentage: true,
        averageTicket: true,
      },
      monthsVisible: true,
    };
  },
  async mounted() {
    this.$router.push({
      query: {
        startMonth: this.search.startMonth,
        startYear: this.search.startYear,
        endMonth: this.search.endMonth,
        endYear: this.search.endYear,
      },
    });
    await this.getAll();
  },
  computed: {
    trader() {
      return this.search.trader;
    },
    installationStatus() {
      return this.search.installationStatus;
    },
    billingStatus() {
      return this.search.billingStatus;
    },
    startMonth() {
      return this.search.startMonth;
    },
    startYear() {
      return this.search.startYear;
    },
    endMonth() {
      return this.search.endMonth;
    },
    endYear() {
      return this.search.endYear;
    },
    textSearch() {
      return this.search.textSearch;
    },
    accountManagerId() {
      return this.search.accountManagerId;
    },
    panoramaColumns() {
      return [
        ...this.initialPanoramaColumns.slice(0, 3),
        ...this.panoramaMonthsColumns,
        ...this.initialPanoramaColumns.slice(3),
      ];
    },
  },
  watch: {
    trader() {
      this.handleFilterList('trader', 'trader');
    },
    textSearch() {
      this.handleFilterList('search', 'textSearch');
    },
    installationStatus() {
      this.handleFilterList('status', 'installationStatus');
    },
    billingStatus() {
      this.handleFilterList('billingStatus', 'billingStatus');
    },
    startMonth() {
      this.$route.query['startMonth'] = this.search['startMonth'];
    },
    startYear() {
      this.$route.query['startYear'] = this.search['startYear'];
    },
    endMonth() {
      this.$route.query['endMonth'] = this.search['endMonth'];
    },
    endYear() {
      this.$route.query['endYear'] = this.search['endYear'];
    },
    accountManagerId() {
      this.handleFilterList('accountManagerId', 'accountManagerId');
    },
  },
  methods: {
    async getAll() {
      try {
        const startYear = parseInt(this.$route.query.startYear, 10);
        const startMonth = parseInt(this.$route.query.startMonth, 10);
        const endYear = parseInt(this.$route.query.endYear, 10);
        const endMonth = parseInt(this.$route.query.endMonth, 10);

        const startDate = new Date(startYear, startMonth - 1, 1);
        const endDate = new Date(endYear, endMonth - 1, 1);

        if (startDate > endDate) {
          this.$bvToast.toast(
            'Data inicial não pode ser maior que a data final',
            {
              title: 'Erro',
              variant: 'danger',
              solid: true,
            },
          );
          return;
        }

        this.isLoading = true;

        if (this.$route.query['billingStatus']) {
          this.$route.query['billingStatus'] =
            NEW_TO_OLD_STATUS[this.$route.query['billingStatus']] ||
            this.$route.query['billingStatus'];
        }

        const result = await API.post('/execute', {
          path:
            '/current-installations' + helpers.toQueryString(this.$route.query),
          method: 'get',
        });
        const traderList = [];
        for (const panoramaInvoice of result.model.panoramaList) {
          if (panoramaInvoice.traderName) {
            traderList.push(panoramaInvoice.traderName);
          }
        }
        this.traderList = traderList;

        this.panoramaMonthsColumns = [];
        const current = new Date(startDate);
        while (current <= endDate) {
          const year = current.getFullYear();
          const month = current.getMonth() + 1;
          this.panoramaMonthsColumns.push({
            name: `${year}, ` + this.convertMonthToString(month),
            key: month.toString().padStart(2, '0') + `${year}` + 'InvoiceData',
            columnType: '(R$)',
            sort: true,
            somatory: true,
            visible: true,
          });
          current.setMonth(current.getMonth() + 1);
        }

        if (this.panoramaMonthsColumns.length) {
          this.panoramaMonthsColumns.at(-1).class = 'divider';
        }

        this.panoramaList = result.model.panoramaList;
        this.panoramaStatusSummaryList = this.createStatusSummaryPanoramaList(
          result.model.panoramaList,
        );
      } catch (error) {
        console.error('Erro ao buscar dados do panorama:', error);
        this.$bvToast.toast(error.message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.isLoading = false;
      }
    },

    convertOldStatusToNewStatus(oldStatus) {
      return OLD_TO_NEW_STATUS[oldStatus] || oldStatus;
    },

    convertMonthToString(month) {
      const months = {
        1: 'JAN',
        2: 'FEV',
        3: 'MAR',
        4: 'ABR',
        5: 'MAI',
        6: 'JUN',
        7: 'JUL',
        8: 'AGO',
        9: 'SET',
        10: 'OUT',
        11: 'NOV',
        12: 'DEZ',
      };
      return months[parseInt(month)];
    },

    createStatusEmptySummary(group, subGroup, status) {
      return {
        group,
        subGroup,
        name: PANORAMA_INVOICE_STATUS[status],
        key: status,
        total: 0,
        qtyInvoices: 0,
        percentageOfTotalOverall: 0,
        percentageOfSubTotal: 0,
        invoicesData: this.createInvoicesDataEmptySummary(),
      };
    },

    createSubGroupEmptySummary(group, subGroup) {
      return {
        group,
        name: PANORAMA_INVOICE_SUBGROUPS[subGroup],
        key: subGroup,
        total: 0,
        qtyInvoices: 0,
        percentageOfTotalOverall: 0,
        percentageOfSubTotal: 0,
        invoicesData: this.createInvoicesDataEmptySummary(),
      };
    },

    createGroupEmptySummary(group) {
      return {
        name: PANORAMA_INVOICE_GROUPS[group],
        key: group,
        total: 0,
        qtyInvoices: 0,
        percentageOfTotalOverall: 0,
        percentageOfSubTotal: 0,
        invoicesData: this.createInvoicesDataEmptySummary(),
      };
    },

    createInvoicesDataEmptySummary() {
      const startYear = parseInt(this.$route.query.startYear, 10);
      const startMonth = parseInt(this.$route.query.startMonth, 10);
      const endYear = parseInt(this.$route.query.endYear, 10);
      const endMonth = parseInt(this.$route.query.endMonth, 10);

      const startDate = new Date(startYear, startMonth - 1, 1);
      const endDate = new Date(endYear, endMonth - 1, 1);

      const invoicesData = new Map();
      const current = new Date(startDate);
      while (current <= endDate) {
        const year = current.getFullYear();
        const month = current.getMonth() + 1;

        invoicesData.set(month.toString().padStart(2, '0') + `${year}`, {
          total: 0,
          qtyInvoices: 0,
        });
        current.setMonth(current.getMonth() + 1);
      }

      return invoicesData;
    },

    /**
     * Transforma a lista de panorama em uma lista de resumo de status
     * @param {PanoramaInvoice[]} panoramaList
     * @returns {PanoramaStatusSummary[]}
     */
    createStatusSummaryPanoramaList(panoramaList) {
      const groupMap = new Map();
      const subGroupMap = new Map();
      const statusMap = new Map();

      // Percorre os grupos e subgrupos
      for (const groupKey of Object.keys(PANORAMA_INVOICE_GROUPED_STATUS)) {
        const groupVal = PANORAMA_INVOICE_GROUPED_STATUS[groupKey];
        groupMap.set(groupKey, this.createGroupEmptySummary(groupKey));

        // Ex.: groupKey = "PAID", "OPEN", "OVERDUE"...
        if (typeof groupVal === 'object') {
          // Subgrupos ou status
          for (const subGroupKey of Object.keys(groupVal)) {
            const subVal = groupVal[subGroupKey];
            if (typeof subVal === 'string') {
              // É um status (chave => valor de texto)
              statusMap.set(
                subGroupKey,
                this.createStatusEmptySummary(groupKey, '', subGroupKey),
              );
            } else {
              subGroupMap.set(
                subGroupKey,
                this.createSubGroupEmptySummary(groupKey, subGroupKey),
              );
              // Pode haver níveis ainda mais internos
              for (const statusKey of Object.keys(subVal)) {
                const label = subVal[statusKey];
                statusMap.set(
                  statusKey,
                  this.createStatusEmptySummary(
                    groupKey,
                    subGroupKey,
                    statusKey,
                  ),
                );
              }
            }
          }
        }
      }

      panoramaList.forEach(installation => {
        const installationInvoicesByGroup = {
          PAID: {
            total: 0,
            qtyInvoices: 0,
          },
          OPEN: {
            total: 0,
            qtyInvoices: 0,
          },
          OVERDUE: {
            total: 0,
            qtyInvoices: 0,
          },
          AGREEMENT: {
            total: 0,
            qtyInvoices: 0,
          },
          LOSS: {
            total: 0,
            qtyInvoices: 0,
          },
        };

        installation['invoicesData'].forEach(invoiceData => {
          const { boletoVeins, status, month, year } = invoiceData;
          const newStatus = this.convertOldStatusToNewStatus(status);
          const statusSummary = statusMap.get(newStatus);
          if (!statusSummary) {
            console.log('Status não encontrado:', newStatus);
            return;
          }

          const totalGroup = groupMap.get('TOTAL');
          if (totalGroup) {
            totalGroup.total += boletoVeins;
            totalGroup.qtyInvoices += 1;
            const currentData = totalGroup.invoicesData.get(
              `${month}${year}`,
            ) || {
              total: 0,
              qtyInvoices: 0,
            };
            totalGroup.invoicesData.set(`${month}${year}`, {
              total: currentData.total + boletoVeins,
              qtyInvoices: currentData.qtyInvoices + 1,
            });
          }

          const group = groupMap.get(statusSummary.group);
          if (group) {
            group.total += boletoVeins;
            group.qtyInvoices += 1;
            const currentData = group.invoicesData.get(`${month}${year}`) || {
              total: 0,
              qtyInvoices: 0,
            };
            group.invoicesData.set(`${month}${year}`, {
              total: currentData.total + boletoVeins,
              qtyInvoices: currentData.qtyInvoices + 1,
            });

            installationInvoicesByGroup[group.key].total += boletoVeins;
            installationInvoicesByGroup[group.key].qtyInvoices += 1;
          }

          const subGroup = subGroupMap.get(statusSummary.subGroup);
          if (subGroup) {
            subGroup.total += boletoVeins;
            subGroup.qtyInvoices += 1;
            const currentData = subGroup.invoicesData.get(
              `${month}${year}`,
            ) || {
              total: 0,
              qtyInvoices: 0,
            };
            subGroup.invoicesData.set(`${month}${year}`, {
              total: currentData.total + boletoVeins,
              qtyInvoices: currentData.qtyInvoices + 1,
            });
          }

          statusSummary.total += boletoVeins;
          statusSummary.qtyInvoices += 1;
          const currentData = statusSummary.invoicesData.get(
            `${month}${year}`,
          ) || {
            total: 0,
            qtyInvoices: 0,
          };
          statusSummary.invoicesData.set(`${month}${year}`, {
            total: currentData.total + boletoVeins,
            qtyInvoices: currentData.qtyInvoices + 1,
          });
        });

        installation['totalPaidInvoiceValue'] =
          installationInvoicesByGroup['PAID'].total;
        installation['totalOpenInvoiceValue'] =
          installationInvoicesByGroup['OPEN'].total;
        installation['totalAgreementInvoiceValue'] =
          installationInvoicesByGroup['AGREEMENT'].total;
        installation['totalOverdueInvoiceValue'] =
          installationInvoicesByGroup['OVERDUE'].total;
        installation['totalLossInvoiceValue'] =
          installationInvoicesByGroup['LOSS'].total;

        installation['qtyPaidInvoice'] =
          installationInvoicesByGroup['PAID'].qtyInvoices;
        installation['qtyOpenInvoice'] =
          installationInvoicesByGroup['OPEN'].qtyInvoices;
        installation['qtyAgreementInvoice'] =
          installationInvoicesByGroup['AGREEMENT'].qtyInvoices;
        installation['qtyOverdueInvoice'] =
          installationInvoicesByGroup['OVERDUE'].qtyInvoices;
        installation['qtyLossInvoice'] =
          installationInvoicesByGroup['LOSS'].qtyInvoices;
      });

      const totalGroup = groupMap.get('TOTAL');
      const totalOverall = totalGroup.total;

      if (!totalOverall) {
        console.log('Nenhuma fatura encontrada');
        return [];
      }

      groupMap.forEach(groupSummary => {
        groupSummary.percentageOfTotalOverall =
          (groupSummary.total / totalOverall) * 100;
        if (groupSummary.total > 0) {
          groupSummary.percentageOfSubTotal =
            (groupSummary.total / groupSummary.total) * 100;
        }

        groupSummary.invoicesData.forEach((invoice, key) => {
          invoice.percentageOfTotalOverall =
            (invoice.total / totalGroup.invoicesData.get(key).total) * 100;
          if (groupSummary.total > 0) {
            invoice.percentageOfSubTotal =
              (invoice.total / groupSummary.total) * 100;
          }
        });
      });

      subGroupMap.forEach(subGroupSummary => {
        subGroupSummary.percentageOfTotalOverall =
          (subGroupSummary.total / totalOverall) * 100;
        if (subGroupSummary.total > 0) {
          subGroupSummary.percentageOfSubTotal =
            (subGroupSummary.total / subGroupSummary.total) * 100;
        }
        subGroupSummary.invoicesData.forEach((invoice, key) => {
          invoice.percentageOfTotalOverall =
            (invoice.total / totalGroup.invoicesData.get(key).total) * 100;
          if (subGroupSummary.total > 0) {
            invoice.percentageOfSubTotal =
              (invoice.total / subGroupSummary.total) * 100;
          }
        });
      });

      statusMap.forEach(statusSummary => {
        statusSummary.percentageOfTotalOverall =
          (statusSummary.total / totalOverall) * 100;
        if (statusSummary.total > 0) {
          statusSummary.percentageOfSubTotal =
            (statusSummary.total / statusSummary.total) * 100;
        }
        statusSummary.invoicesData.forEach((invoice, key) => {
          invoice.percentageOfTotalOverall =
            (invoice.total / totalGroup.invoicesData.get(key).total) * 100;
          if (statusSummary.total > 0) {
            invoice.percentageOfSubTotal =
              (invoice.total / statusSummary.total) * 100;
          }
        });
      });

      return this.buildSummary(groupMap, subGroupMap, statusMap);
    },

    buildSummary(groupMap, subGroupMap, statusMap) {
      const finalResult = [];
      groupMap.forEach((groupData, groupKey) => {
        // Monta o objeto "group"
        const groupObj = {
          name: groupData.name || groupKey,
          ...groupData,
          status: [],
          subGroups: [],
        };

        statusMap.forEach((statusData, statusKey) => {
          // Verifica se o status pertence a este grupo e a este subgrupo
          if (statusData.group === groupKey && statusData.subGroup === '') {
            // Monta o objeto de status
            const statusObj = {
              name: statusData.name || statusKey,
              ...statusData,
            };
            groupObj.status.push(statusObj);
          }
        });

        // Agora percorremos o subGroupMap para encontrar subgrupos do mesmo group
        subGroupMap.forEach((subGroupData, subGroupKey) => {
          if (subGroupData.group === groupKey) {
            // Monta objeto para o subgrupo
            const subGroupObj = {
              name: subGroupData.name || subGroupKey,
              ...subGroupData,
              status: [],
            };

            // Por fim, iteramos sobre o statusMap para encontrar os status daquele subgrupo
            statusMap.forEach((statusData, statusKey) => {
              // Verifica se o status pertence a este grupo e a este subgrupo
              if (
                statusData.group === groupKey &&
                statusData.subGroup === subGroupKey
              ) {
                // Monta o objeto de status
                const statusObj = {
                  name: statusData.name || statusKey,
                  ...statusData,
                };
                subGroupObj.status.push(statusObj);
              }
            });

            groupObj.subGroups.push(subGroupObj);
          }
        });

        finalResult.push(groupObj);
      });

      return finalResult;
    },

    translateInstallationStatus(status) {
      const translatedStatus = INSTALLATION_STATUS_IN_PTBR[status];
      return translatedStatus.length > 21
        ? `${translatedStatus.substring(0, 21)}...`
        : translatedStatus;
    },

    /**
     * Método para filtrar a lista
     * @return {function(): void}
     */
    async handleFilterList(queryProp, searchProp) {
      this.$route.query[queryProp] = this.search[searchProp];
      await this.getAll();
    },

    defineQtyDaysInStatusColor(qtyDaysInStatus) {
      qtyDaysInStatus = Math.ceil(qtyDaysInStatus);
      if (qtyDaysInStatus > 30 && qtyDaysInStatus <= 45) {
        return '#EBE76C';
      } else if (qtyDaysInStatus > 45 && qtyDaysInStatus <= 60) {
        return '#FFB000';
      } else if (qtyDaysInStatus > 60) {
        return '#F24C3D';
      } else {
        return '';
      }
    },
    sortListByKey(columnKey) {
      this.sortDirection = defineArrowDirection(
        this.currentColumnFiltered,
        columnKey,
        this.sortDirection,
      );
      this.currentColumnFiltered = columnKey;
      if (/^\d{6}InvoiceData$/.test(columnKey)) {
        sortPanoramaInvoiceByBoletoVeins(
          this.panoramaList,
          columnKey,
          this.sortDirection === 'ASC',
        );
        return;
      }
      sortByProperty(this.panoramaList, columnKey, this.sortDirection);
    },
    setInstallationStatusColor(status) {
      return setPanoramaInvoiceInstallationStatusColor(status);
    },
    setInvoiceStatusColor(status) {
      return setPanoramaInvoiceStatusColor(status);
    },
    toggleAllFields() {
      if (Object.values(this.selectedFields).includes(false)) {
        this.selectedFields = {
          invoiceValue: true,
          qtyInvoices: true,
          overallPercentage: true,
          subTotalPercentage: true,
          averageTicket: true,
        };
      } else {
        this.selectedFields = {
          invoiceValue: false,
          qtyInvoices: false,
          overallPercentage: false,
          subTotalPercentage: false,
          averageTicket: false,
        };
      }
    },
    toggleMonthsVisibility() {
      this.monthsVisible = !this.monthsVisible;
      this.panoramaMonthsColumns.forEach(column => {
        column.visible = this.monthsVisible;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.panorama-table {
  display: block;
  max-height: 95vh !important;
  height: auto !important;
  margin-top: 1rem;
  margin-bottom: 1rem;

  .divider {
    border-right: 2px solid gray;
  }

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    position: sticky;
    left: 105px;
    background-color: #e7e7e7;
    min-width: 380px;
  }

  td:nth-child(3),
  th:nth-child(3) {
    position: sticky;
    left: 485px;
    background-color: #e7e7e7;
    min-width: 147px;
  }

  td.total,
  th.total {
    background-color: #e7e7e7;
  }

  tr:nth-child(odd) td.total {
    background-color: #e7e7e7;
  }

  tr:nth-child(even) td.total {
    background-color: #f2f2f2;
  }

  tr:nth-child(odd) td:nth-child(-n + 3) {
    background-color: #e7e7e7;
  }

  tr:nth-child(even) td:nth-child(-n + 3) {
    background-color: #f2f2f2;
  }
}

.panorama-table .money-cell {
  text-align: right;
}
</style>
